// extracted by mini-css-extract-plugin
export default {"fragments":"styles_fragments__zJn6R","iconDefault":"styles_iconDefault__DTWOC","iconSmall":"styles_iconSmall__8gB3i","metro":"styles_metro__fL+Mw","icon":"styles_icon__qt5Hy"};